import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        localStorage.setItem("session_token", data.session_token);
      } catch {
        // session exchange failed — landing will show logged-out state
      }
      window.location.href = sessionStorage.getItem("auth_return") || "/";
      sessionStorage.removeItem("auth_return");
    })();
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-[#F4F2ED] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Loader2 size={28} className="animate-spin text-flame" />
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-neutral-500">LOGGING YOU IN...</p>
    </div>
  );
}
